import React, { useContext } from "react";
import "./skills.css";
import { Theme } from "../App";

function Skills() {
  const { theme } = useContext(Theme);

  const skills = [
    {
      img: "./html.png",
      style: { backgroundColor: "#ff5722" },
    },
    {
      img: "./css.png",
      style: { backgroundColor: "#2196f3" },
    },
    {
      img: "./js.png",
      style: {},
    },
    {
      img: "./typescript.png",
      style: {},
    },
    {
      img: "./react.png",
      style: {},
    },
    {
      img: "./tailwind.png",
      style:{}
    },
    {
      img: "./nodejs.png",
      style: { backgroundColor: "#7dbe42" },
    },
    {
      img: "./expressjs.png",
      style: { backgroundColor: "#828282" },
    },
    {
      img: "./mongodb.png",
      style: {},
    },
  ];
  return (
    <div className={`skils-comp skils-comp-${theme}`}>
      <div className={`skills-container skills-container-${theme}`}>
        <h1>Tech Stack</h1>
        <div className="stack-logos">
          {skills.map((skill) => (
            <img src={skill.img} style={skill.style} alt="loading" />
          ))}
        </div>
      </div>
    </div>
  );
}

export default Skills;
